import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useSettings } from '../context/SettingsContext'
import { Nav } from './partials/Nav';
import { API_URL } from './Constants';

const Users = () => {
  const settings = useSettings();
  const [ users, setUsers ] = useState(null)

  useEffect(() => {
    document.title = 'User Management | ValParx Admin'
    let token = settings.userToken;
    
    if (token && !users) {
      var myHeaders = new Headers();
      myHeaders.append("vp-session-token", token);

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(API_URL + "/getusers", requestOptions)
        .then(response => response.json())
        .then(result => {
          //console.log(result)

          if (result.code == 400) {
            setUsers([])
          } else {
            setUsers(result.users)
          }
        })
        .catch(error => {
          console.log('error', error)
        });
    }

  }, []);

  const userLevel = (level) => {
    if (level == 1) {
      return 'Manager';
    }

    if (level == 2) {
      return 'Runner';
    }

    if (level == 3) {
      return 'Needs Approval';
    }
  }

  return (
    <div className='min-h-screen flex items-start justify-center py-12 px-4 sm:px-6 lg:px-8'>
      <Nav /> 
      <div className="max-w-5xl w-full space-y-8 pt-20">
        <div className='flex justify-between items-center mb-12'>
          <h2 className='mb-0'>User Management</h2>
          <Link to={"/users/add/"} className="group relative w-full flex justify-center py-2 px-4 border font-bold border-accent border-solid text-md rounded-md text-white hover:text-accent bg-accent hover:bg-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-50 transition items-center max-w-160 m-0">
            Add User
            <FontAwesomeIcon icon="fa-solid fa-circle-plus" className='ml-2' />
          </Link>
        </div>
        
        {users ? (
          (users.length > 0 ? (
            <ul id='sites' className={`w-full max-w-2xl mx-auto`}>
              {users.map((user, index) => (
                <li key={index}>
                  <Link to={"/users/edit/"+user.id} className=" uppercase py-1 font-bold flex justify-between items-center">
                    <span className='overflow-x-clip text-gray-900'>{user.name} (Level: {userLevel(user.level)})</span>
                    <FontAwesomeIcon icon="fa-arrow-right fa-solid" className='mr-2 text-sm text-accent ' />
                  </Link>
                </li>
              ))}
            </ul>
           ) : (
            <p className='text-center font-medium'>No active users found. <br></br>You can start adding some with the button above.</p>
           ))
        ) : (
          <p className='text-blueGray-500 items-center flex text-center justify-center'>
            <span>Loading Users...</span>
            <FontAwesomeIcon icon="fa-solid fa-spinner" className='text-sm ml-2 fa-spin' />
          </p>
        )}
      </div>
    </div>
  )
}

export default Users